import { computed } from "vue";
import { useStore } from "vuex";
import { averagePercentages } from "@/utils/calculateFieldCompletionPercent";
import { resolveProfilePercentage } from "@/utils/resolveProfilePercentage";

/**
 * Profile completion bar + value sent to POST /profiles/percentage.
 * Falls back to the last known API/session percentage while child forms hydrate.
 *
 * @param {() => unknown[]} getSectionPercents
 */
export function useProfileFillPercent(getSectionPercents) {
  const store = useStore();

  const storedPercentage = computed(() => {
    return (
      resolveProfilePercentage(sessionStorage.getItem("percentage")) ??
      resolveProfilePercentage(store.getters.getPercentageNum) ??
      resolveProfilePercentage(store.getters.getProfile?.percentage)
    );
  });

  const fillPercent = computed(() => {
    const avg = averagePercentages(getSectionPercents());
    if (avg > 0) {
      return avg;
    }

    return storedPercentage.value ?? 0;
  });

  return { fillPercent, storedPercentage };
}
